import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Column } from '@app/modules/table/classes/column.class';

export class TrainingProgramColumn extends Column {
    title = 'training.trainingProgram';
    property = 'trainingProgram.name';
    type: CellDisplay = CellDisplay.string;
}
